import type { SVGProps } from "react";
const SvgTiktok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12 2.5c4.478 0 6.718 0 8.109 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109S16.479 21.5 12 21.5c-4.478 0-6.718 0-8.109-1.391S2.5 16.479 2.5 12Z"
    />
    <path
      fill="currentColor"
      d="M10.394 11.778a.75.75 0 0 0 .212-1.485l-.106.742zM17.5 10.25a.75.75 0 0 0 0-1.5v1.5M14.25 6a.75.75 0 0 0-1.5 0h1.5m-.75 8.5h-.75A2.75 2.75 0 0 1 10 17.25v1.5a4.25 4.25 0 0 0 4.25-4.25zM10 18v-.75a2.75 2.75 0 0 1-2.75-2.75h-1.5A4.25 4.25 0 0 0 10 18.75zm-3.5-3.5h.75A2.75 2.75 0 0 1 10 11.75v-1.5a4.25 4.25 0 0 0-4.25 4.25zM10 11v.75q.202 0 .394.028l.106-.743.106-.742A4 4 0 0 0 10 10.25zm7.5-1.5v-.75c-.775 0-1.608-.32-2.244-.85-.636-.532-1.006-1.212-1.006-1.9h-1.5c0 1.245.664 2.315 1.544 3.05.88.736 2.048 1.2 3.206 1.2zm-4-3.5h-.75v8.5h1.5V6z"
    />
  </svg>
);
export default SvgTiktok;
